import { IGrowthBookFeatures } from 'growthbook/growthbook.interfaces';
import { useFeatureIsOn } from 'growthbook/useFeatureIsOn';

export const useGrowthbookFeatures = (config: {
  [key: string]: {
    condition: (keyof IGrowthBookFeatures)[];
    title: string;
    description: string;
    docsLink: string;
  };
}): { growthbookFeatures: (keyof IGrowthBookFeatures)[] } => {
  const growthbookFeatures = [];

  if (Object.keys(config).length === 0) {
    return {
      growthbookFeatures,
    };
  }

  for (const key of Object.keys(config)) {
    const hasDisabledFeature = config[key].condition.some((feature) => {
      return !useFeatureIsOn(feature);
    });

    if (hasDisabledFeature) {
      growthbookFeatures.push(key);
    }
  }

  return {
    growthbookFeatures,
  };
};
